import type { Editor } from '@tiptap/core';
import type { EditorExtensionsConfig } from '../types/EditorExtensionsConfig';
export const getExtensionOption = <
  K extends keyof EditorExtensionsConfig = keyof EditorExtensionsConfig,
>(
  editor: Editor | null | undefined,
  key: K,
): Required<EditorExtensionsConfig>[K] => {
  if (!editor) {
    throw new Error('Editor is not defined');
  }
  const opts = editor.options.extensionConfig || ({} as any);
  if (!opts || !opts[key]) {
    throw new Error(`Extension option "${key}" is not defined`);
  }
  return opts[key] as any;
};
